export default {"src":"/_next/static/media/database.39ec4fd4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};